import {Injectable} from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";
import {HttpErrorResponse} from "@angular/common/http";
import {NotificationComponent} from "./notification.component";
import {ErrorService} from "../error.service";

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor(
        public notifier: MatSnackBar,public errorService : ErrorService
    ) {
    }
    public showNotification(message, type, duration?, verticalPosition?, horizontalPosition?) {
        const _notificationType = type !== undefined ? type : 'success';
        this.notifier.openFromComponent(NotificationComponent, {
            duration: duration || 4000,
            horizontalPosition: horizontalPosition || 'center',
            verticalPosition: verticalPosition || 'bottom',
            data: { message: message, notificationType: _notificationType, notifier: this.notifier }
        });
    }

    showServerError(error: HttpErrorResponse) : void {
        let message = this.errorService.getServerMessage(error);
        this.showNotification(message, 'error');
    }

}